$ = jQuery;
function header() {
  $(document).ready(function() {
    $('#oz-main-navigation').on('show.bs.collapse', function() {
      $('.content-header .site-logo img').addClass('active');
      $('.content-header').addClass("opened");
    });

    $('#oz-main-navigation').on('hidden.bs.collapse', function() {
      $('.content-header .site-logo img').removeClass('active');
      $('.content-header').removeClass("opened");
    });

    stickyHeader();

    var gallery = $('.photoswipe-gallery');
    if(gallery.length) {
      gallery.masonry({
        itemSelector: 'img',
        fitWidth: true,
        containerStyle: {position: 'relative'},
      });
    }
  });
}

window.onscroll = function() {
  stickyHeader();

  var sectionIds = $('a.scroll-link');
  var headerHeight = Math.round($('.content-header').outerHeight()) + 200;

    sectionIds.each(function(){
      var container = $(this).attr('href').substring(1);
      if ($(container).length) {
        var containerOffset = $(container).offset().top - headerHeight;
        var containerHeight = $(container).outerHeight();
        var containerBottom = containerOffset + containerHeight;
        var scrollPosition = $(document).scrollTop();

        if(scrollPosition < containerBottom - 20 && scrollPosition >= containerOffset - 20){
          $(this).addClass('scrolled');
        } else{
          $(this).removeClass('scrolled');
        }
      }
    });
};

window.onload = function() {
  stickyHeader();
}

function stickyHeader() {
  if (window.scrollY > 2) {
    $('.content-header').addClass("sticky");
  } else {
    $('.content-header').removeClass("sticky");
  }

  // Hide menu when click on link (only mobile)
  $('.content-header .menu--main ul li a').click(function() {
    $('.content-header .menu--main .navbar-toggler[aria-expanded="true"] .navbar-toggler-icon').click();
  });
}
